module.exports = __webpack_public_path__ + "img/701-b015bd.png";